import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=f21a1628&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"
import style1 from "./Footer.vue?vue&type=style&index=1&id=f21a1628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f21a1628",
  null
  
)

export default component.exports